<div class="row-col inbox-card" [ngClass]="{'detail-view' : showDetailView}">
  <h3>{{ 'DASHBOARD.notifications' | translate }}</h3>

  <gp-back-link
    [linkText]="'INBOX.view_all_notifications'"
    (linkClick)="backToList()">
  </gp-back-link>
  <router-outlet></router-outlet>
</div>
